import React from "react";
import PropTypes from "prop-types";
// Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { limitlessImage } from "@limitless/images";
import ResponsiveImage from "../responsive-image/ResponsiveImage";
const useStyles = makeStyles(() => ({
  container: {
    padding: "70px 34px 0"
  },
  imageSizing: {
    width: "100%"
  },
  subHeaderContent: {
    paddingTop: 24
  }
}));
const OptInWelcome = ({
  content
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.container,
    spacing: 2,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 7,
    xl: 6
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    color: "textPrimary"
  }, content.header), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary",
    className: classes.subHeaderContent
  }, content.subHeader)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 5,
    xl: 6
  }, /*#__PURE__*/React.createElement(ResponsiveImage, {
    imageStyles: classes.imageSizing,
    images: content.images,
    imageAlt: "sign-up-welcome",
    noImageSrc: limitlessImage
  })));
};
OptInWelcome.propTypes = {
  content: PropTypes.object.isRequired
};
export default OptInWelcome;